<wuc-picture
    *ngIf="collectivity"
    [imageDesktop]="imageUrl"
    [imageWidth]="sizes[location]"
    [imageHeight]="sizes[location]"
    [alt]="'Collectiviteits korting ' + collectivity.naam"
></wuc-picture>
